import "./AssessmentGoalsList.scss";
import { useState } from "react";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  IconButton,
  Popover,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import LoadingImage from "components/LoadingImage";
import { InfoOutlined } from "@mui/icons-material";
import { APISubmitInstanceEvent, APISubmitQCMResponse } from "utils/api";
import ReactMarkdown from "react-markdown";
import rehypeHighlight from "rehype-highlight";
import remarkGfm from "remark-gfm";
import components from "utils/markdown";
import {
  goalHasQcmTask,
  handleAssessmentSubmit,
  handleEventSubmit,
  handleQCMCheckboxChange,
  handleQCMRadioChange,
  handleQCMTextChange,
} from "utils/utils";
import { useTranslation } from "react-i18next";
import CollapsableSimpleCard from "views/LabInstancePage/components/CollapsableSimpleCard";

export default function AssessmentGoalsList({ goals, instance }) {
  const { t } = useTranslation();

  const [formData, setFormData] = useState(
    goals.map((goal) =>
      goal.value.map((t) => ({
        value: "",
        qid: t.id,
        error: false,
        helperText: "",
      })),
    ),
  );
  const [hintAnchorEl, setHintAnchorEl] = useState(null);
  const [hintText, setHintText] = useState(null);
  const [isHintOpen, setIsHintOpen] = useState(false);
  const [loadingStates, setLoadingStates] = useState(goals.map(() => false));
  const [successSubmitStates, setSuccessSubmitStates] = useState(goals.map(() => false));

  const handleOpenHint = (
    event: React.MouseEvent<HTMLButtonElement>,
    hintText,
  ) => {
    setHintAnchorEl(event.currentTarget);
    setHintText(hintText);
    setIsHintOpen(true);
  };

  // mutation for creating instance event
  // const createInstanceEventMutation = useMutation({
  //   mutationFn: ({ instance_id, event }: any) => {
  //     return APIPostInstanceEvent(instance_id, event);
  //   }
  // });

  return (
    <div className="goals-list">
      {goals &&
        goals.map((goal, goal_i) => (
          <div className="flex flex-row">
            <CollapsableSimpleCard
              card_title={goal.title}
              step={goal_i}
              goal_done={true}
              is_goal={true}
              onClick={() => {
                // if (goalTaskStartedClickCount[goal_i] < MAX_GOAL_TASK_STARTED_CLICK_COUNT) {
                //   createInstanceEventMutation.mutate({
                //     instance_id: instance.id,
                //     event: {
                //       name: InstanceEventNameTaskStarted,
                //       value: {
                //         "goal_id": goal.id,
                //       },
                //     },
                //   }, {
                //     onSuccess: (data) => {
                //       setGoalTaskStartedClickCount((prev) => prev.map((_, index) => index === goal_i ? prev[index] + 1 : prev[index]));
                //     },
                //     onError: (error) => {
                //       console.log("error", error);
                //       setGoalTaskStartedClickCount((prev) => prev.map((_, index) => index === goal_i ? prev[index] + 1 : prev[index]));
                //     }
                //   });
                // }
              }}
            >
              {/* {goal.description && (
                <Typography className="goal-card-text">
                  <b>Description:</b> {goal.description}
                </Typography>
              )} */}
              {goal.value &&
                goal.value.map((task, task_i) => (
                  <>
                    {task.type === "qcm" && (
                      <form className="qcm-form !sm:mx-[80px]">
                        <FormControl
                          error={formData[goal_i][task_i].error}
                          aria-labelledby="qcm-label"
                          component="fieldset"
                          fullWidth
                          variant="standard"
                        >
                          {task.answers_type === "single" && (
                            <>
                              <FormLabel id="qcm-label">{task.title}</FormLabel>
                              <RadioGroup
                                aria-labelledby="qcm-label"
                                name={`quiz-${goal_i}-${task_i}`}
                                value={formData[goal_i][task_i].value}
                                onChange={(e) =>
                                  handleQCMRadioChange(
                                    e,
                                    goal_i,
                                    task_i,
                                    formData,
                                    setFormData,
                                  )
                                }
                              >
                                {task.proposed_answers.map(
                                  (answer: string, i: number) => {
                                    return (
                                      <FormControlLabel
                                        key={i}
                                        value={answer}
                                        control={<Radio size="small" />}
                                        label={answer}
                                      />
                                    );
                                  },
                                )}
                              </RadioGroup>
                              <FormHelperText
                                className={`${!formData[goal_i][task_i].error &&
                                    formData[goal_i][task_i].helperText
                                    ? "!text-green"
                                    : ""
                                  }`}
                              >
                                {formData[goal_i][task_i].helperText}
                              </FormHelperText>
                            </>
                          )}
                          {task.answers_type === "multiple" && (
                            <>
                              <FormLabel id="qcm-label">
                                {task.title}{" "}
                              </FormLabel>

                              <FormGroup>
                                {task.proposed_answers.map(
                                  (answer: string, i: number) => {
                                    return (
                                      <FormControlLabel
                                        key={i}
                                        control={
                                          <Checkbox
                                            checked={formData[goal_i][
                                              task_i
                                            ].value.includes(answer)}
                                            onChange={(e) =>
                                              handleQCMCheckboxChange(
                                                e,
                                                goal_i,
                                                task_i,
                                                answer,
                                                formData,
                                                setFormData,
                                              )
                                            }
                                            name={answer}
                                          />
                                        }
                                        label={answer}
                                      />
                                    );
                                  },
                                )}
                              </FormGroup>
                              <FormHelperText
                                className={`${!formData[goal_i][task_i].error &&
                                    formData[goal_i][task_i].helperText
                                    ? "!text-green"
                                    : ""
                                  }`}
                              >
                                {formData[goal_i][task_i].helperText}
                              </FormHelperText>
                            </>
                          )}
                          {task.answers_type === "text" && (
                            <>
                              <FormLabel id="qcm-label" className="!mb-1">{task.title}</FormLabel>
                              <TextField
                                error={formData[goal_i][task_i].error}
                                value={formData[goal_i][task_i].value}
                                className="!mb-1"
                                onChange={(e) =>
                                  handleQCMTextChange(
                                    e,
                                    goal_i,
                                    task_i,
                                    formData,
                                    setFormData,
                                  )
                                }
                              />
                              <FormHelperText
                                className={`!mt-1 ${!formData[goal_i][task_i].error &&
                                    formData[goal_i][task_i].helperText
                                    ? "!text-green"
                                    : ""
                                  }`}
                              >
                                {formData[goal_i][task_i].error
                                  ? formData[goal_i][task_i].helperText
                                    ? formData[goal_i][task_i].helperText
                                    : t('please-fill-in-the-answer')
                                  : ""}
                              </FormHelperText>
                            </>
                          )}
                        </FormControl>
                      </form>
                    )}
                    {task.type === "content" && (
                      <ReactMarkdown
                        components={components}
                        rehypePlugins={[rehypeHighlight]}
                        remarkPlugins={[remarkGfm]}
                        className="goal-content-text prose prose-base mx-[5px] my-[30px] max-w-none !font-poppins sm:mx-[80px]"
                        children={task.content}
                      />
                    )}
                    {task.type === "terminal" && (
                      <div className="mx-[30px] mb-[80px] mt-[20px] max-w-[full] !font-poppins">
                        <div className="rounded-b-box rounded-se-box relative flex h-11 w-full items-center justify-start space-x-2 overflow-x-auto rounded-t-[20px] bg-[#15191e] px-7">
                          <span className="w-3 h-3 bg-gray-600 rounded-full"></span>
                          <span className="w-3 h-3 bg-gray-600 rounded-full"></span>
                          <span className="w-3 h-3 bg-gray-600 rounded-full"></span>
                        </div>
                        <div className="bg-gray-[#15191e] h-[264px] w-full rounded-b-[20px] border-t-0">
                          <embed
                            src={task.url}
                            width="100%"
                            height="100%"
                            className="rounded-b-lg"
                          />
                        </div>
                      </div>
                    )}
                    {task.type.toLowerCase() === "event" && (
                      <>
                        <ReactMarkdown
                          components={components}
                          rehypePlugins={[rehypeHighlight]}
                          remarkPlugins={[remarkGfm]}
                          className="goal-content-text prose prose-base mx-[5px] my-[30px] max-w-none !font-poppins sm:mx-[80px]"
                          children={task.content}
                        />
                        <FormControl
                          error={formData[goal_i][task_i].error}
                          aria-labelledby="qcm-label"
                          component="fieldset"
                          fullWidth
                          variant="standard"
                          className="!px-[5px] md:!pl-[80px] md:!pr-[40px]"
                        >
                          <FormHelperText
                            className={`!mt-1 ${!formData[goal_i][task_i].error &&
                                formData[goal_i][task_i].helperText
                                ? "!text-green"
                                : ""
                              }`}
                          >
                            {formData[goal_i][task_i].error
                              ? formData[goal_i][task_i].helperText
                                ? formData[goal_i][task_i].helperText
                                : t('an-error-has-occured-please-try-again')
                              : ""}
                          </FormHelperText>
                          <Button
                            className="goal-submit-btn"
                            type="submit"
                            disableRipple
                            variant="text"
                            onClick={(e) =>
                              handleEventSubmit(
                                e,
                                goal_i,
                                task_i,
                                task.event_number,
                                formData,
                                setFormData,
                                setLoadingStates,
                                loadingStates,
                                instance,
                                APISubmitInstanceEvent,
                              )
                            }
                          >
                            {loadingStates[goal_i] ? (
                              <LoadingImage />
                            ) : (
                              t('submit')
                            )}
                          </Button>
                        </FormControl>
                      </>
                    )}
                  </>
                ))}
              {goalHasQcmTask(goal) && (
                <Button
                  className={`goal-submit-btn md:!mr-[40px] ${successSubmitStates[goal_i] ? "!text-green":""}`}
                  type="submit"
                  disableRipple
                  variant="text"
                  disabled={successSubmitStates[goal_i]}
                  onClick={(e) =>
                    handleAssessmentSubmit(
                      e,
                      goal_i,
                      formData,
                      setFormData,
                      goals,
                      setLoadingStates,
                      loadingStates,
                      instance,
                      APISubmitQCMResponse,
                    ).then((ok) => {
                      if (ok) {
                        setSuccessSubmitStates((prev) => {
                          prev[goal_i] = true;
                          return [...prev];
                        });
                      }
                    })
                  }
                >
                  {loadingStates[goal_i] ? <LoadingImage /> : successSubmitStates[goal_i] ? t('submitted') : t('submit')}
                </Button>
              )}
            </CollapsableSimpleCard>
            {goal.description && (
              <IconButton
                onClick={(e) => handleOpenHint(e, goal.description)}
                className="!mt-[17px] h-fit self-start !text-[#407EC9]"
                aria-label="open-hint"
                disableTouchRipple
                disableRipple
                disableFocusRipple
              >
                <InfoOutlined />
              </IconButton>
            )}
          </div>
        ))}
      <Popover
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={() => setIsHintOpen(false)}
        anchorEl={hintAnchorEl}
        id="hint-popover"
        open={isHintOpen}
        sx={{
          "& .MuiPopover-paper": {
            padding: "30px 17px",
            borderRadius: "20px",
            border: "0.2px solid rgba(64, 126, 200, 0.4)",
            boxShadow: "0px 7px 29px rgba(100, 100, 111, 0.2)",
          },
        }}
      >
        <div className="font-poppins text-[16px] font-light">
          <div className="font-medium">Reminder:</div>
          <div>{hintText}</div>
        </div>
      </Popover>
    </div>
  );
}
